import { Box } from '@mui/material';
import { useMemo, useRef } from 'react';
import { Header, Page, Toolbox } from 'redesign';
import { useGetCompaniesInfinite } from 'hq/hooks/queryHooks/companies/use-get-companies';
import { SmallLoader } from 'shared/components';
import { CompaniesFilterToolbox } from './components/companies-filter-form/companies-filter-form';
import { useCompaniesInfiniteScroll } from './hooks/use-companies-infinite-scroll';
import { COMPANIES_FILTER_INITIAL_VALUE } from './companies.types';
import { CompaniesList } from './companies-list';
import { useExternalParams } from '../../../../shared/hooks';

export const Companies = () => {
  const [params, setParams] = useExternalParams(COMPANIES_FILTER_INITIAL_VALUE);
  const companiesQuery = useGetCompaniesInfinite(params.filter);

  const flatData = useMemo(
    () => companiesQuery.data?.pages.flatMap((page) => page.items) ?? [],
    [companiesQuery.data]
  );

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const { onContentScroll } = useCompaniesInfiniteScroll(
    scrollContainerRef,
    companiesQuery,
    flatData.length
  );

  const isInitialLoading = companiesQuery.isLoading && flatData.length === 0;

  return (
    <Page
      header={<Header titleText="Bedrijven" />}
      toolbox={
        <Toolbox>
          <CompaniesFilterToolbox params={params} setParams={setParams} />
        </Toolbox>
      }
      contentRef={scrollContainerRef}
      onContentScroll={onContentScroll}
    >
      <CompaniesList
        params={params}
        companiesQuery={companiesQuery}
        flatData={flatData}
        isInitialLoading={isInitialLoading}
      />
      {companiesQuery.isFetching && flatData.length > 0 ? (
        <Box display="flex" justifyContent="center" py={4}>
          <SmallLoader show />
        </Box>
      ) : null}
    </Page>
  );
};
